import React, {useState, Component} from 'react';
import * as firebase from 'firebase'
import { Redirect, Route } from 'react-router'
import Header from './Header.js';
import Footer from './Footer.js';

export default class ApplicationForm extends Component {
  // const [weightText, setWeightText] = useState("")
constructor(props){
   super(props);
   this.state={
     firstName: '',
     surName: '',
    redirectBack: false,
    gender: 'Male',
    educationLevel: 'No Education',
    age: '18',
    stateOfOrigin: 'Abia',
    answer: '',
    redirectFront: false
   }
} 


componentDidMount(){
       let number = localStorage.getItem('mobileNumber')

      // console.log(number)

      if(number!==null){

         const dbRefObject = firebase.database().ref().child('users');
           dbRefObject.once('value', snapshot => {
             // convert messages list from snapshot
             const usersObject = snapshot.val();
       
             if (usersObject) {
               const usersList = Object.keys(usersObject).map(key => ({
                 ...usersObject[key],
                 uid: key,
               }));
              // var user = firebase.auth().currentUser;
       
      // this.setState({ loading: false})
       let mobileExist 
       for(let i=0; i<usersList.length; i++){
      
        if(usersList[i].mobileNumber===number){
          mobileExist = true
          // console.log('true')
          // console.log(usersList)
//mobileExist = true
           //this.setState({name: this.state.sellersData[i].name, gender: this.state.sellersData[i].gender, address:this.state.sellersData[i].address})
        }
        else{
          mobileExist = false

         

          //  this.setState({name: '', gender: 'male', address:'', loader: false})
        
        }
          } 
      //  console.log(mobileExist)

      if(mobileExist===false){
         // localStorage.setItem('mobileNumber', this.state.mobileNumber)
this.setState({redirectBack: false})
      }

     else if(mobileExist===true){
        this.setState({redirectBack: true})

      }
             
             } else {
             // console.log('nothing')

                this.setState({loading: false})

              //  this.setState({name: '', gender: 'male', address: '', loader: false})

               // this.setState({ users: null, });
             }
           });
          }
          else{
            this.setState({redirectBack: true})
          }
      }
  
      onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    
      };

      handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
      }

      onNextClick = event => {
        let number = localStorage.getItem('mobileNumber')

      if(this.state.firstName !== ''&& this.state.surName !=='' && this.state.answer){
        localStorage.setItem('firstName', this.state.firstName)
        localStorage.setItem('surName', this.state.surName)
        localStorage.setItem('gender', this.state.gender)
        localStorage.setItem('age', this.state.age)
        localStorage.setItem('stateOfOrigin', this.state.stateOfOrigin)
        localStorage.setItem('educationLevel', this.state.educationLevel)
        localStorage.setItem('answer', this.state.answer)
  localStorage.setItem('passedSecondStage', 'true')

  this.setState({redirectFront: true})
      }

 
      




      }


render(){
  const {
   firstName,
   surName,
   age,
   gender,
   stateOfOrigin,
   educationLevel,
   answer
  } = this.state;


 
  
  if (this.state.redirectBack === false) {
  return (
      <>
<Header/>
  <div class="container" style={{maxWidth: 700, marginTop: 125, marginBottom: 150}}>
  <form action="/action_page.php" class="was-validated">
  <div class="form-group">
    <label for="uname">First Name:</label>
    <input type="text" class="form-control" id="uname" placeholder="Enter Firstname" 
    name="firstName"
    onChange={this.onChange}
    value={firstName}
    maxlength='25' 
    required/>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>
  <div class="form-group">
    <label for="uname">Surname:</label>
    <input type="text" class="form-control" id="uname" placeholder="Enter Surname"
    name="surName"
    onChange={this.onChange}
    value={surName}
    maxlength='25' 
     required/>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>

  <div class="form-group">
    <label for="uname">Gender:</label>
    <select
    name="gender"
     value={gender}
     onChange={this.handleChange}
                            class="form-control"
                            
                          >
                            <option value="Male"> Male</option>
                            <option value="Female">Female</option>
                            
                          
                          </select>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>
  <div class="form-group">
    <label for="uname">Age (Years):</label>
    <select
    value={age}
    name="age"
    onChange={this.handleChange}
                            class="form-control"
                            
                          >
                            <option value="18 "> 18 </option>
                            <option value="19 "> 19 </option>
                            <option value="20 "> 20 </option>
                            <option value="21 "> 21 </option>
                            <option value="22 "> 22 </option>
                            <option value="23 "> 23 </option>
                            <option value="24 "> 24 </option>
                            <option value="25 "> 25 </option>
                            <option value="26 "> 26 </option>
                            <option value="27 "> 27 </option>
                            <option value="28 "> 28 </option>
                            <option value="29 "> 29 </option>
                            <option value="30 "> 30 </option>
                            <option value="31 "> 31 </option>
                            <option value="32 "> 32 </option>
                            <option value="33 "> 33 </option>
                            <option value="34 "> 34 </option>
                            <option value="35 "> 35 </option>
                            <option value="36 "> 36 </option>
                            <option value="37 "> 37 </option>
                            <option value="38 "> 38 </option>
                            <option value="39 "> 39 </option>
                            <option value="40 "> 40 </option>

                          
                            
                          
                          </select>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>

  <div class="form-group">
    <label for="uname">State of Origin:</label>
    <select
    name="stateOfOrigin"
    value={stateOfOrigin}
    onChange={this.handleChange}
                            class="form-control"
                            
                          >
                            <option value="Abia"> Abia</option>
                            <option value="Adamawa">Adamawa</option>
                            <option value="Akwa Ibom">Akwa Ibom</option>
                            <option value="Anambra">Anambra</option>
                            <option value="Bauchi">Bauchi</option>
                            <option value="Bayelsa">Bayelsa</option>
                            <option value="Benue">Benue</option>
                            <option value="Borno">Borno</option>
                            <option value="Cross River">Cross River</option>

                            <option value="Delta"> Delta</option>
                            <option value="Ebonyi">Ebonyi</option>
                            <option value="Edo">Edo</option>
                            <option value="Ekiti">Ekiti</option>
                            <option value="Enugu">Enugu</option>
                            <option value="Gombe">Gombe</option>
                            <option value="Imo">Imo</option>
                            <option value="Jigawa">Jigawa</option>
                            <option value="Kaduna">Kaduna</option>

                            <option value="Kano"> Kano</option>
                            <option value="Katsina">Katsina</option>
                            <option value="Kebbi">Kebbi</option>
                            <option value="Kogi">Kogi</option>
                            <option value="Kwara">Kwara</option>
                            <option value="Lagos">Lagos</option>
                            <option value="Nasarawa">Nasarawa</option>
                            <option value="Niger">Niger</option>
                            <option value="Ogun">Ogun</option>

                            <option value="Ondo"> Ondo</option>
                            <option value="Osun">Osun</option>
                            <option value="Oyo">Oyo</option>
                            <option value="Plateau">Plateau</option>
                            <option value="Rivers">Rivers</option>
                            <option value="Sokoto">Sokoto</option>
                            <option value="Taraba">Taraba</option>
                            <option value="Yobe">Yobe</option>
                            <option value="FCT">FCT</option>

                          </select>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>
  <div class="form-group">
    <label for="uname">Education Level:</label>
    <select
    value={educationLevel}
    onChange={this.handleChange}
    name="educationLevel"
                            class="form-control"
                            
                          >
                            <option value="No Education"> No Education</option>
                            <option value="FSLC">FSLC</option>
                            <option value="SSCE">SSCE</option>
                            <option value="OND/NCE">OND/NCE</option>
                            <option value="HND">HND</option>
                            <option value="Bachelors' Degree">Bachelors' Degree</option>
                            <option value="Masters">Masters</option>
                          
                          </select>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>

  <div class="form-group">
    <label for="uname">What can you do with &#8358;200,000</label>
    <textarea class="form-control" rows="5" id="uname" name="answer"
    onChange={this.onChange}
    value={answer}
    required placeholder="What can you do with &#8358;200,000 ?"></textarea>
    <div class="valid-feedback"></div>
    <div class="invalid-feedback">Please fill out this field.</div>
  </div>
  
  {/* <div class="form-group form-check">
    <label class="form-check-label">
      <input class="form-check-input" type="checkbox" name="remember" required/> I agree on blabla.
      <div class="valid-feedback"></div>
      <div class="invalid-feedback">Check this checkbox to continue.</div>
    </label>
  </div> */}
  <button type="submit" class="btn btn-primary" onClick={this.onNextClick}>Next</button>
</form>



</div>
<Footer/>
{this.state.redirectFront === true && (
          <Redirect to={'/validate-account'} />
        )}
</>
    );
      }
    else return (
      <Redirect to={'/'} />
    )
  }
}

//export default ApplicationForm;
